import { FreeGameService } from './service/freeGameService'
export const freeGameService = new FreeGameService()
